import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import DimpleDivider from '@tds/core-dimple-divider';

import SalesRepDashboard from '../../salesRepDashboard';
import ContactCentreSalesRepDashboard from '../../ContactCentre/salesRepDashboard';
import Orders from '../../orders';
import BAOrderFulFillmentDashboard from '../../businessApps/businessAppsOrderFulfillmentDashboard';
import QuoteApprovalDashboard from '../../QuoteApprovalDashboard';
import { SubNavWrapper, SubNavButton, SubNavButtonActive } from './css';
import { CONSTANT } from '../../utils/constant';
import BusinessAppOrders from '../../businessApps/businessAppsSalesRepDashboard';
import IotSalesRepDashboard from '../../iot/iotMyOrdersDashboard';
import IotOrderFulfillmentDashboard from '../../iot/iotOrderFulfillmentDashboard';

const Dashboards = ({ availableDashboards, location }) => {
  if (availableDashboards.length === 0) return null;

  const [selectedDashboard, setSelectedDashboard] = useState('');

  useEffect(() => {
    setSelectedDashboard(availableDashboards[0]);
  }, [availableDashboards]);

  const getDashboard = key => {
    switch (key) {
      case 'SALES_REP_DASHBOARD':
        return <SalesRepDashboard location={location} />;
      case 'CC_SALES_REP_DASHBOARD':
        return <ContactCentreSalesRepDashboard location={location} />;
      case 'SOV_DASHBOARD':
        return <Orders />;
      case 'QUOTE_APPROVAL_DASHBOARD':
        return <QuoteApprovalDashboard />;
      case 'BUSINESS_APP_DASHBOARD':
        return <BusinessAppOrders />;
      case 'IOT_SALES_REP_DASHBOARD':
        return <IotSalesRepDashboard />;
      case 'BA_SALES_REP_DASHBOARD':
        return <BusinessAppOrders />;
      case 'BA_ORDER_FULFILLMENT_DASHBOARD':
        return <BAOrderFulFillmentDashboard />;
      case 'IOT_SOV_DASHBOARD':
        return <IotOrderFulfillmentDashboard />;
      default:
        return null;
    }
  };

  return (
    <>
      <SubNavWrapper>
        {availableDashboards.map(dashboard => {
          if (dashboard === selectedDashboard)
            return (
              <SubNavButtonActive
                onClick={() => setSelectedDashboard(dashboard)}
              >
                {CONSTANT.DASHBOARD_LABELS[dashboard]}
              </SubNavButtonActive>
            );
          return (
            <SubNavButton onClick={() => setSelectedDashboard(dashboard)}>
              {CONSTANT.DASHBOARD_LABELS[dashboard]}
            </SubNavButton>
          );
        })}
      </SubNavWrapper>
      <DimpleDivider />
      {getDashboard(selectedDashboard)}
    </>
  );
};

Dashboards.propTypes = {
  availableDashboards: PropTypes.arrayOf(PropTypes.string).isRequired,
  location: PropTypes.objectOf(PropTypes.string).isRequired
};

export default Dashboards;
